import { baseApi } from '@shared/api/baseApi'
import type {
  AttachCardPayload,
  BuyCoursePayload,
  BuySubscriptionPayload,
  InvoiceResponse,
  PaymentMethodsResponse,
  PaymentStatusResponse,
} from './types'

export const buySubscription = async (payload: BuySubscriptionPayload): Promise<InvoiceResponse> => {
  const { data } = await baseApi.post<InvoiceResponse>('/api/payment/subscription', payload)
  return data
}

export const buyCourse = async (payload: BuyCoursePayload): Promise<InvoiceResponse> => {
  const { data } = await baseApi.post<InvoiceResponse>('/api/payment/course', payload)
  return data
}

export const attachCard = async (payload: AttachCardPayload): Promise<InvoiceResponse> => {
  const { data } = await baseApi.post<InvoiceResponse>('/api/payment/attach-card', payload)
  return data
}

export const getPaymentStatus = async (trackingUuid: string): Promise<PaymentStatusResponse> => {
  const { data } = await baseApi.get<PaymentStatusResponse>(`/api/payment/${trackingUuid}/status`)
  return data
}

export const getPaymentMethods = async (): Promise<PaymentMethodsResponse> => {
  const { data } = await baseApi.get<PaymentMethodsResponse>('/api/payment-methods')
  return data
}

export const deletePaymentMethod = async (paymentMethodId: number): Promise<void> => {
  await baseApi.delete(`/api/payment-methods/${paymentMethodId}`)
}

export const setMainPaymentMethod = async (paymentMethodId: number): Promise<void> => {
  await baseApi.post(`/api/payment-methods/${paymentMethodId}/set-main`)
}

/**
 * DEV-only: имитация вебхука провайдера. Регистрируется на бэке только при `env != "prod"`.
 * Используется для e2e-тестов без реальной оплаты — завершает платёж нужным статусом
 * и (при success + поля карты) сохраняет карту в payment-methods.
 */
export interface SimulateWebhookPayload {
  tracking_uuid: string
  status: 'success' | 'failed' | 'cancelled' | 'refunded'
  recurrent_token?: string
  masked_card_number?: string
  card_brand?: string
}

export const simulateProviderWebhook = async (
  provider: 'robokassa' | 'tribute',
  payload: SimulateWebhookPayload
): Promise<void> => {
  await baseApi.post(`/api/_dev/webhook/${provider}/simulate`, payload)
}
